<template>
  <modal-form-helper :data="{...mdldata, title:'Opportunity - Biz Dev'}" :form="post">
    <template #body>
      <div ref="field_defs" class="d-none">
        <!--company-->
        <div ref="field_company">
          <form-input :required="false"
                      v-model="post.company.name" :form="post"
                      name="company.name"
                      label="Company"
                      @input="searchNameDebounced"
                      :debounce="true"
                      :debounce-settings="{
                        url: genUrl('companies', null, 'search'),
                        route_name: 'company_details',
                        param: 'name',
                        label: 'name'}"
          />
        </div>
        <div ref="field_employees">
          <form-input :required="false"
                      v-model="post.company_detail.employees" :form="post"
                      name="company_detail.employees" label="Employees"/>
        </div>
        <div ref="field_company_type">
          <form-select2
              :required="false"
              name="company_detail.company_type"
              label="Company Type"
              :form="post"
              v-model="post.company_detail.company_type"
              :options="drdata.company_types"
              :config="{
                label: 'title',
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_company_house_no">
          <form-input
              :required="false"
              v-model="post.company_detail.company_house_no"
              :form="post"
              name="company_detail.company_house_no"
              label="Companies House"
            />
        </div>

        <!--company_detail-->
        <div ref="field_sectors">
          <form-select2
              :required="false"
              name="details.sectors"
              label="Sector"
              :form="post"
              v-model="post.company_detail.sectors"
              :options="drdata.sectors"
              :config="{
                label: 'title',
                multiple: true,
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_sub_sectors">
          <form-select2
              :required="false"
              name="details.sub_sectors"
              label="Sub Sector"
              :form="post"
              v-model="post.company_detail.sub_sectors"
              :options="optgroupSubsectors"
              :config="{
                multiple: true,
                preventTransform: true,
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_source">
          <form-select2
              :required="false"
              name="company_detail.source"
              label="Source"
              :form="post"
              v-model="post.company_detail.source"
              :options="drdata.sources"
              :config="{
                id: 'id',
                label: 'title',
                ajax: {
                  paginated: false,
                  url: genUrl('source_type', null,  'get'),
                  term: 'title',
                }
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_ownership">
          <form-select2
              :required="false"
              name="company.ownership"
              label="Ownership"
              :form="post"
              v-model="post.company.ownership"
              :options="drdata.ownerships"
              :config="{
                label: 'name',
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_revenue">
          <form-input :required="false"
                      v-model="post.company.revenue" :form="post"
                      name="company.revenue" label="Revenue"/>
        </div>
        <div ref="field_ebitda">
          <form-input :required="false"
                      v-model="post.company.ebitda" :form="post"
                      name="company.ebitda" label="EBITDA"/>
        </div>
        <div ref="field_country">
          <form-select2
              :required="false"
              name="company.country"
              label="Country"
              :form="post"
              v-model="post.company.country"
              :options="drdata.country_codes"
              :config="{
                id: 'code',
                label: 'name',
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_business_description">
          <form-input :required="false"
                      v-model="post.business_description" :form="post"
                      name="business_description" label="Business Description"/>
        </div>
        <div ref="field_pe_companies">
          <form-select2
              :required="false"
              name="company.pe_companies"
              label="PE/VC"
              :form="post"
              v-model="post.company.pe_companies"
              :options="pe_companies"
              :config="pe_company_ajax_config"
              :classes="['form-select-solid']"
          />
        </div>

        <!--address-->
        <div ref="field_branch">
          <form-input :required="false"
                      v-model="post.address.branch" :form="post"
                      name="address.branch" label="Branch"/>
        </div>
        <div ref="field_street_line_one">
          <form-input :required="false"
                      v-model="post.address.street_line_one" :form="post"
                      name="address.street_line_one" label="Address - Street 1"/>
        </div>
        <div ref="field_street_line_two">
          <form-input :required="false"
                      v-model="post.address.street_line_two" :form="post"
                      name="address.street_line_two" label="Address - Street 2"/>
        </div>
        <div ref="field_city">
          <form-input :required="false"
                      v-model="post.address.city" :form="post"
                      name="address.city" label="City"/>
        </div>
        <div ref="field_state">
          <form-input :required="false"
                      v-model="post.address.state" :form="post"
                      name="address.state" label="State"/>
        </div>
        <div ref="field_postcode">
          <form-input :required="false"
                      v-model="post.address.postcode" :form="post"
                      name="address.postcode" label="Postcode"/>
        </div>

        <!--contact-->
        <div ref="field_title">
          <form-select2
              :required="false"
              name="title"
              label="Title"
              :form="post"
              v-model="post.contact.title"
              :options="drdata.titles"
              :config="{
                          id: 'id',
                          label: 'title',
                          ajax: {
                            paginated: false,
                            url: genUrl('user_title', null,  'get'),
                            term: 'title',
                          }
                        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_first_name">
          <form-input :required="false"
                      v-model="post.contact.first_name" :form="post"
                      name="contact.first_name" label="First Name"/>
        </div>
        <div ref="field_last_name">
          <form-input :required="false"
                      v-model="post.contact.last_name" :form="post"
                      name="contact.last_name" label="Last Name"/>
        </div>
        <div ref="field_direct_mobile">
          <form-input v-model="post.contact.direct_mobile" :required="false" :form="post" name="contact.direct_mobile" label="Mobile Phone"/>
        </div>
        <div ref="field_direct_phone">
          <form-input v-model="post.contact.direct_phone" :required="false" :form="post" name="contact.direct_phone" label="Office Phone"/>
        </div>
        <div ref="field_email">
          <form-input v-model="post.contact.email" :required="false" :form="post" name="contact.email" label="Email"/>
        </div>
        <div ref="field_job_title">
          <form-input v-model="post.contact.job_title" :required="false" :form="post" name="contact.job_title" label="Job title"/>
        </div>
        <div ref="field_users">
          <form-select2
              :required="false"
              name="contact.users"
              label="Relationships"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.contact.users"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <!--opportunity-->
        <div ref="field_pipeline">
          <form-select2
              :required="false"
              name="pipeline"
              label="Pipeline"
              :form="post"
              @change="onChangePiplineStage($event)"
              v-model="post.pipeline"
              :options="pipelines"
              :config="{
                id: 'id',
                label: 'name',
                searchable: false,
                clearable: false,
              }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_pipeline_stage">
          <form-select2
              :required="false"
              name="pipeline_stage"
              label="Pipeline stage"
              :form="post"
              v-model="post.pipeline_stage"
              :options="pipeline_stages"
              :config="search_conf_pstage"
              :classes="['form-select-solid form-select-sm']"
          />
        </div>
        <div ref="field_lead_type">
          <form-select2
              :required="false"
              name="lead_types"
              label="Lead types"
              :form="post"
              v-model="post.lead_type"
              :options="lead_types"
              :config="{
          id: 'id',
          label: 'title',
          searchable: false,
          clearable: false,
        }"
              :classes="['form-select-solid']"
          />
        </div>
        <div ref="field_pitch_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Pitch Date</slot>
          </label>
          <date-picker v-model="post.pitch_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="pitch_date"></has-error>
        </div>
        <div ref="field_expected_exit_date">
          <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
            <slot name="labelText">Expected Exit Date</slot>
          </label>
          <date-picker v-model="post.expected_exit_date"
                       input-class="form-control form-control-sm form-control-solid"/>
          <has-error :form="post" field="expected_exit_date"></has-error>
        </div>
        <div ref="field_internal_introducers">
          <form-select2
              :required="false"
              name="internal_introducers"
              label="Introducers"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.internal_introducers"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_team_members">
          <form-select2
              :required="false"
              name="team_members"
              label="Team Members"
              placeholder=""
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.team_members"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: true,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>
        <div ref="field_owner">
          <form-select2
              :required="false"
              name="owner"
              label="Owner"
              placeholder="Select One"
              :form="post"
              :template="userTemplate"
              :selection-template="userSelectionTemplate"
              v-model="post.owner"
              :options="users"
              :config="{
                    id: 'id',
                    label: 'name',
                    multiple: false,
                    ajax: {
                      paginated: true,
                      url: genUrl('users', null,  'search'),
                      term: 'query',
                    }
                  }"
              :classes="['form-select-solid']"
          >
          </form-select2>
        </div>

        <div ref="field_opportunity_status">
          <form-select2
              :required="false"
              name="opportunity_status"
              label="Opportunity Status"
              :form="post"
              v-model="post.opportunity_status"
              :options="status"
              :config="{
                  id: 'id',
                  label: 'title',
                  searchable: false,
                  clearable: false,
                }"
              :classes="['form-select-solid']"
          />
        </div>

        <!--Custom fields-->
        <div v-for="field in fields.custom_fields">
          <div :ref="`field_${field.field_key}`">
            <div v-if="field.field_type==='text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='long_text'">
              <form-input :required="false" v-model="post[field.field_key]" :form="post"
                          :name="field.field_key" :label="field.title"/>
            </div>
            <div v-else-if="field.field_type==='multiple_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label',
                              multiple: true,
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='single_option'">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label">
                {{ field.title }}
              </label>
              <select2
                  :required="false"
                  v-model="post[field.field_key]"
                  :options="field.options"
                  :config="{
                              label: 'label'
                            }"
              />
            </div>
            <div v-else-if="field.field_type==='date'" :id="`field_${field.field_key}`">
              <label class="align-items-center dm-fs-0-9-rem fw-bolder form-label d-flex">
                {{ field.title }}
              </label>
              <date-picker
                          :value="post[field.field_key]"
                          @input="(val) => setDateForce(field.field_key, val)"
                         :typeable="false"
                           input-class="form-control form-control-sm form-control-solid mb-3 w-100"
                           format="DD-MM-YYYY"/>
            </div>
            <has-error :form="post" :field="field.field_key"></has-error>
          </div>
        </div>
      </div>

      <div ref="fields_rend">
        <div v-for="section in sections">
          <h4 v-show="section.title_show">{{ section.title }}</h4>
          <div class="row" v-for="(col, colIndex) in Array.from({length: section.max_rows})">
            <div class="col-md-6" v-for="(dir, dirIndex) in section.directions">
              <div v-if="section.fields[dirIndex][colIndex]"
                   :ref="`rend_field_${section.fields[dirIndex][colIndex].field}`"></div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </modal-form-helper>
</template>

<script>
import cm from "@mxn/create"
import get_custom_fields from '../company/get_custom_fields'
import UserSelector from "@cc/includes/UserSelector.vue";

export default {
  components: {UserSelector},
  mixins: [cm, get_custom_fields],
  props: {
    source: '',
    url_key: {
      default: 'opportunity'
    },
    project: {default: null},
    asModal: {default: true},
    // customFields: {default: []},
  },
  data() {
    return {
      form_category: 'opp_biz',
      id: null,
      isModal: true,

      searchingName: false,
      nameDuplicates: [],

      acKey: 'ac_key_1',
      contactLocked: null,

      drdata: {
        companies: [],
        titles: [],
        ownerships: [],
        contacts: [],
        company_type: [],
        sectors: [],
        sub_sectors: [],
        sources: [],
        trading_status: [],
        ownership: [],
        relationship: [],
        corporate_status: [],
        currency: [],
        country_codes: [],
        users: [],

      },
      pe_companies: [],
      // fields: this.customFields,
      first_name_opts: [],
      pipelines: [],
      pipeline_stages: [],
      lead_types: [],
      users: [this.$user],
      post: Form.make({
        contact: {
          title: null,
          first_name: '',
          last_name: '',
          direct_mobile: '',
          direct_phone: '',
          job_title: '',
          email: '',
          users: [this.$user.id],
        },
        company: {
          name: '',
          ownership: null,
          country: null,
          ebitda: '',
          revenue: '',
          pe_companies: [],
        },
        company_detail: {
          source: '',
          employees: null,
          company_type: null,
          sectors: [],
          sub_sectors: [],
          company_house_no: '',
        },
        address: {
          branch: '',
          street_line_one: '',
          street_line_two: '',
          city: '',
          state: '',
          postcode: '',
          // country: '',
        },
        business_description: '',
        pitch_date: null,
        expected_exit_date: null,
        pipeline: '',
        lead_type: '',
        pipeline_stage: '',
        internal_introducers: [],
        team_members: [],
        owner: this.$user.id,
        opportunity_status:'',
      }),
      test:this.$user,
      status:[],
    };
  },
  computed: {
    pe_company_ajax_config(){
      return {
        multiple: true,
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null,  'search'),
          term: 'name',
          params: {pe_only: 1},
        }
      }
    },
    first_name_ajax_config() {
      return {
        id: 'first_name',
        label: 'name',
        raw: {
          tags: true
        },
        ajax: {
          paginated: false,
          url: this.genUrl('contact', null, 'search'),
          term: 'query',
          params: {company: this.post.company},
        }
      }
    },
    search_conf_company() {
      return {
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('companies', null, 'search'),
          term: 'name',
        }
      }
    },
    search_conf_pstage() {
      return {
        id: 'id',
        label: 'name',
        ajax: {
          paginated: false,
          url: this.genUrl('pipeline_stages'),
          term: 'name',
          params: {pipeline: this.post.pipeline}
        }
      }
    },
    optgroupSubsectors() {
      if (!this.post.company_detail.sectors) return []

      let data = []
      this.drdata.sectors.filter(sec => this.post.company_detail.sectors.map(String).includes(String(sec.id))).forEach(sec => {
        data.push({
          id: sec.id,
          text: sec.title,
          children: this.drdata.sub_sectors.filter(sc => sec.id == sc.sector).map(sc => ({id: sc.id, text: sc.title}))
        })
      })

      return data
    },
  },
  created() {
    this.searchNameDebounced = _.debounce(() => this.searchName(), this.SEARCH_DEBOUNCE_MS)
  },
  mounted() {
    this.fetchCompanyHelpers()

    axios.get(this.genUrl('form_settings', null, 'get_form_data'))
        .then(({data}) => {
            console.log(data)
            this.pipelines = data.pipelines;
            this.lead_types = data.lead_types;
            let default_pipelines = (data.pipelines).find((el) => (el.name.toLowerCase()).trim() == "origination team - prospecting")

            if(default_pipelines){
              this.post.pipeline = default_pipelines?default_pipelines.id:''
              this.getPipelinesStages(default_pipelines.id)
            }

        })

    let url = this.genUrl('form_settings', null, 'custom_fields')
    this.getCustomFields(url)
    // this.fetchRenderFields(url)
    this.fetchOpportunityStatus()


  },
  methods: {
    searchName() {
    //
    },
    getUrl(){
      return this.genUrl(this.url_key, null, 'biz_dev_create')
    },
    fetchCompanyHelpers() {
      axios.get(this.genUrl('companies', null, 'data'))
          .then(({data}) => {
            this.drdata = {
              ...this.drdata,
              ...data,
            }
            // let default_ownership = (data.ownerships).find((el) => (el.name.toLowerCase()).trim() == "private")
            // let default_company_type = (data.company_types).find((el) => (el.title.toLowerCase()).trim() == "trade")
            //
            // this.post.details.ownership = default_ownership.id
            // this.post.details.company_type = default_company_type.id

            this.users = [{...this.drdata.user}]
            // this.preCreate_()
          })
          .catch(err => console.error(err))
    },
    onChangePiplineStage(event){
      this.getPipelinesStages(event)
    },
    getPipelinesStages(pipeline_id){
      axios.get(this.genUrl('pipeline_stages'),{params: {pipeline: pipeline_id}})
      .then( ({data}) => {
        console.log(data.data)
          let default_pipeline_stage = (data.data).find((el) => (el.name.toLowerCase()).trim() == "qualified")
          this.pipeline_stages = data.data
          this.post.pipeline_stage = default_pipeline_stage ? default_pipeline_stage.id : ''
      })
    },
    postCreate(data){
      if(this.source == 'quick_menu'){
        // this.close()
        // return
      }

      return this.$router.push({name: 'crm_opportunity_details', params: {id: data.id}})
    },
    getResultValue(result) {
      console.log(result)
      this.contactLocked = false
      return result.name
    },
    handleSubmit(result) {
      // debugger
      this.contactLocked = true
      this.post.first_name = result.first_name
      this.post.last_name = result.last_name
      this.acKey = _.random(true)
      // this.$nextTick(() => {
      //   try{
      //     this.$refs.firstNameAutoComplete.$refs.input.focus()
      //   }catch (e){
      //     console.error("CANT_FOCUS_AUTOCOMPLETE_XR")
      //   }
      // })
      console.log(result)
    },
    searchDebounced(input) {
      this.post.first_name = input

      return new Promise((resolve, reject) => {
        if (input.length < 2) {
          return resolve([])
        }
        axios.get(this.genUrl('contact', null, 'search'), {
          params: {query: input, company: this.post.company}
        })
            .then(({data}) => {
              resolve(data.data)
            })
            .catch(err => reject(err))
      })
    },

    extraData() {
      return {
        pitch_date: this.momentMixin(this.post.pitch_date, 'YYYY-MM-DD'),
        expected_exit_date: this.momentMixin(this.post.expected_exit_date, 'YYYY-MM-DD'),
      }
    },
    edit() {
      this.startCompLoading()
      axios.get(this.genUrl(this.url_key, this.id, 'post'))
          .then(({data}) => {
            const contact = data.contacts[0]
            console.log(contact)
            this.post.update({
              ...this.post,
              ...data,
              ...contact
            })
          })
          .catch(err => console.error(err))
          .finally(() => this.endCompLoading())
    },

    fetchOpportunityStatus(){
      this.startCompLoading()
      axios.get(this.genUrl('opportunity_status', null, 'get'))
          .then(({data}) => {
            console.log(data)
            this.status = data.data

            if(this.status.length){
              //default status active
              let default_status = (data.data).find((el) => (el.title.toLowerCase()).trim() == "active")
              this.post.opportunity_status = default_status?default_status.id:''
            }

            this.endCompLoading()
          })
          .catch(err => {
            this.toastLaraValidation(err)
            this.endCompLoading()
          })
    }
  },
}
</script>

<style scoped>
input.autocomplete-input {
  font-size: unset;
  background-image: unset;
  padding: 0.55rem 0.77rem;
  border-radius: 0.325rem;
}
</style>